export default __webpack_public_path__ + "img/8be9712448fd68f5de3e2b0133584ebe.png";